import axios from 'axios';

// --- Add this block for static files ---
export const STATIC_BASE_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:8001'
  : 'https://apiviztech.in:8001';

// --- API base ---
const BASE_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:8001/api'
  : 'https://apiviztech.in:8001/api';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;


// // src/api.js
// import axios from 'axios';

// const BASE_URL = window.location.hostname === 'localhost'
//   ? 'http://localhost:8000/api'
//   : 'https://apiviztech.in:8000/api';

// const api = axios.create({ baseURL: BASE_URL });

// api.interceptors.request.use(config => {
//   const token = localStorage.getItem('token'); // ✅ Must match this key
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// export default api;
